import { render, staticRenderFns } from "./avenir.vue?vue&type=template&id=3ca4afd4"
import script from "./avenir.vue?vue&type=script&lang=js"
export * from "./avenir.vue?vue&type=script&lang=js"
import style0 from "./avenir.vue?vue&type=style&index=0&id=3ca4afd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports